<!-- 管理者からのお知らせ -->
<template>
  <div v-if="infoListData.length > 0" class="com_notice1">
    <h3>管理者からのお知らせ</h3>
    <div>
      <div v-for="info in infoListData" :key="info.contentId" class="item1">
        <span class="date1 roboto">{{ info.postPeriod }}</span>
        <span class="text1"
          ><router-link
            :to="`/${info.detailPath}/categoryId/${info.categoryId}/contentsId/${info.contentId}`"
            class="com_link1"
            >{{ info.contentsTitle }}</router-link
          ></span
        >
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { AxiosError } from "axios";
import apiAuthClient from "@/util/apiClientAuth";
import {
  outputDebugLogs,
  formatMessage,
  getTargetDate,
  getUserInfo,
} from "@/Common";
import { AppConstants } from "@/constants/AppConstants";
import messages from "@/assets/messages.json";

interface Item {
  categoryId: string;
  categoryName: string;
  subCategoryName: string;
  contentId: string;
  postPeriod: string;
  contentsTitle: string;
  imptFlg: boolean;
  newFlg: boolean;
  fileFlg: boolean;
  detailPath: string;
  updateFormPath: string;
}

export default defineComponent({
  name: "AnnouncementAreaComponent",
  setup() {
    const infoListData = ref<Item[]>([]);
    const { agCode, userId } = getUserInfo();

    onMounted(async () => {
      try {
        outputDebugLogs("管理者からのお知らせ取得");

        // 管理者からのお知らせ取得API
        const response = await apiAuthClient.post("/api/Info/getKanriInfo", {
          systemKbn: process.env.VUE_APP_SYSTEM_KBN,
          userId: userId.value,
          agCode: agCode.value,
          targetDate: getTargetDate(""),
        });
        infoListData.value = response.data.infoListData;
        outputDebugLogs(
          "管理者からのお知らせ取得成功 件数：" + infoListData.value.length
        );
      } catch (error: unknown) {
        const axiosError = error as AxiosError;
        outputDebugLogs("Error: " + axiosError.message);
        alert(formatMessage(messages.ERR_SYS003, "管理者からのお知らせ取得"));
      } finally {
        //何か入れるかも
      }
    });

    return { infoListData };
  },
});
</script>
